import React, { useState } from 'react';

import { Button } from '@/components/ui/button';

import { AritoIcon, AritoFormV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { BasicInfo, DetailsTab, OtherTab } from './tabs';
import { initialValues, searchSchema } from '../schema';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const [formValues, setFormValues] = useState(initialValues);

  const handleSubmit = (data: BanHangPayload) => {
    onSearch(data);
  };

  const handleDirectSubmit = () => {
    onSearch(formValues);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Bảng kê chi tiết thu tiền theo hóa đơn'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={data => {
          setFormValues(data);
          handleSubmit(data);
        }}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
        bottomBar={
          <>
            <Button className='bg-[rgba(15,118,110,0.9)] text-white hover:bg-[rgba(15,118,110,1)]' type='submit'>
              <AritoIcon icon={884} marginX='4px' />
              Đồng ý
            </Button>

            <Button onClick={onClose} variant='outline'>
              <AritoIcon icon={885} marginX='4px' />
              Huỷ
            </Button>
          </>
        }
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
